import React from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css';
import BlogDetails from './components/BlogDetails';
import Navbar from './components/Navbar';
import Home from './page/Home';

function App() {



  return (
    <>

      <BrowserRouter>
      <Navbar />

      <Routes >



<Route path='/' element={<Home />}  />
<Route path='/blog/:postId' element={<BlogDetails />}  />
      </Routes>
       
      </BrowserRouter>


      <Toaster />



    </>
  );
}

export default App;
